/* eslint-disable */
import React, { useEffect, useState } from "react";
import Statistics from "..";
import {
  getStatisticsSessions,
  getStatisticsSuccess,
} from "../../../actions";
import "./styles.scss";
import { connect } from "react-redux";
import Popup from "reactjs-popup";;
import PeriodSelector from "../../PeriodSelector";
import infoIcon from "../../../assets/icons/info-gray-new.svg";
import { history } from "../../../config/stores";

const Registrations = ({
  getStatisticsSuccess,
  getStatisticsSessions,
  sessions,
}) => {
  const [selPeriod, setSelPeriod] = useState({
    startDate: null,
    endDate: null,
  });
  const [hasUserChangedPeriod, setHasUserChangedPeriod] = useState(false);
  const [selectedPeriodLabel, setSelectedPeriodLabel] = useState("All time");
  const [selectedPeriodType, setSelectedPeriodType] = useState("all");

  useEffect(() => {
    getStatisticsSuccess({ type: "sessions", loading: true });
    getStatisticsSessions();
  }, []);

  useEffect(() => {
    // Only trigger API call when user has actually changed the period
    if (hasUserChangedPeriod) {
      const apiPayload = {
        startDate: selPeriod.startDate || "",
        endDate: selPeriod.endDate || "",
      };
      
      getStatisticsSessions(apiPayload);
    }
  }, [selPeriod, hasUserChangedPeriod]);

  const handlePeriodApply = (periodData) => {
    setSelPeriod({
      startDate: periodData.startDate,
      endDate: periodData.endDate,
    });
    setSelectedPeriodLabel(periodData.label);
    setSelectedPeriodType(periodData.type);
    setHasUserChangedPeriod(true);
  };

  const handleLanguageInfo = ({ value, label, info }) => {
    // Language name to code mapping
    const languageNameToCode = {
      "Bulgarian": "bg",
      "English": "en", 
      "German": "de",
      "Italian": "it",
      "French": "fr",
      "Greek": "gr",
      "Spanish": "es",
      "Romanian": "ro"
    };
    
    // Navigate to the users list page with period parameters and language filter
    const queryParams = new URLSearchParams();
    
    if (selPeriod.startDate) {
      queryParams.set('startDate', selPeriod.startDate);
    }
    if (selPeriod.endDate) {
      queryParams.set('endDate', selPeriod.endDate);
    }
    if (selectedPeriodLabel !== "All time") {
      queryParams.set('periodLabel', selectedPeriodLabel);
    }
    if (selectedPeriodType !== "all") {
      queryParams.set('periodType', selectedPeriodType);
    }
    if (value) {
      // Convert language name to code, or use value as-is if it's already a code
      const languageCode = languageNameToCode[value] || value.toLowerCase();
      queryParams.set('lang', languageCode);
    }
    
    const queryString = queryParams.toString();
    const url = queryString ? `/dashboard/users/list?${queryString}` : '/dashboard/users/list';
    
    history.push(url);
  };

  const handleUsersListClick = (role = "") => {
    // Navigate to the users list page with period parameters and role filter
    const queryParams = new URLSearchParams();
    
    if (selPeriod.startDate) {
      queryParams.set('startDate', selPeriod.startDate);
    }
    if (selPeriod.endDate) {
      queryParams.set('endDate', selPeriod.endDate);
    }
    if (selectedPeriodLabel !== "All time") {
      queryParams.set('periodLabel', selectedPeriodLabel);
    }
    if (selectedPeriodType !== "all") {
      queryParams.set('periodType', selectedPeriodType);
    }
    if (role) {
      queryParams.set('role', role);
    }
    
    const queryString = queryParams.toString();
    const url = queryString ? `/dashboard/users/list?${queryString}` : '/dashboard/users/list';
    
    history.push(url);
  };

  return (
    <div 
      className="statistics-sessions-container col"
      style={{ overflow: "auto" }}
    >
      {/* Row 1: USERS title and period selector */}
      <div className="registrations-header">
        <h1 className="users-title">
          <b>USERS</b>
        </h1>
        <div className="period-selector">
          <p className="period-label">
            {selectedPeriodLabel}
          </p>
          <Popup
            className="popup-header-options-container"
            trigger={<div className="settings-icon" />}
            position="bottom right"
            closeOnDocumentClick
          >
            {(close) => (
              <PeriodSelector
                selectedPeriod={selectedPeriodType}
                onApply={(periodData) => {
                  handlePeriodApply(periodData);
                  close();
                }}
              />
            )}
          </Popup>
        </div>
      </div>

      {/* Row 2: Blue background with total registered users */}
      <div className="total-users-row">
        <div className="indicator" />
        <div className="total-users-content">
          <span className="users-count">{sessions.usersCount || 0}</span>
          <span className="users-text">REGISTERED IN THE APP</span>
        </div>
        <img 
          src={infoIcon} 
          alt="Info" 
          className="info-icon" 
          onClick={() => handleUsersListClick()}
          style={{ cursor: "pointer" }}
        />
      </div>

      {/* Row 3: User role breakdown */}
      <div className="user-roles-container">
        <div className="user-role-row">
          <div className="indicator gray" />
          <div className="role-content">
            <span className="role-count">{sessions?.countByRole?.landlordWithTenant || 0}</span>
            <span className="role-text">LANDLORDS WITH TENANT</span>
          </div>
          {(sessions?.countByRole?.landlordWithTenant || 0) > 0 && (
            <img 
              src={infoIcon} 
              alt="Info" 
              className="info-icon" 
              onClick={() => handleUsersListClick("landlordWithTenant")}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>

        <div className="user-role-row">
          <div className="indicator gray" />
          <div className="role-content">
            <span className="role-count">{sessions?.countByRole?.landlordWithoutTenant || 0}</span>
            <span className="role-text">LANDLORDS WITHOUT TENANT</span>
          </div>
          {(sessions?.countByRole?.landlordWithoutTenant || 0) > 0 && (
            <img 
              src={infoIcon} 
              alt="Info" 
              className="info-icon" 
              onClick={() => handleUsersListClick("landlordWithoutTenant")}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>

        <div className="user-role-row">
          <div className="indicator gray" />
          <div className="role-content">
            <span className="role-count">{sessions?.countByRole?.tenant || 0}</span>
            <span className="role-text">TENANTS</span>
          </div>
          {(sessions?.countByRole?.tenant || 0) > 0 && (
            <img 
              src={infoIcon} 
              alt="Info" 
              className="info-icon" 
              onClick={() => handleUsersListClick("tenant")}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>

        <div className="user-role-row">
          <div className="indicator gray" />
          <div className="role-content">
            <span className="role-count">{sessions?.countByRole?.tenantWithLandlord || 0}</span>
            <span className="role-text">TENANTS WITH LANDLORD</span>
          </div>
          {(sessions?.countByRole?.tenantWithLandlord || 0) > 0 && (
            <img 
              src={infoIcon} 
              alt="Info" 
              className="info-icon" 
              onClick={() => handleUsersListClick("tenantWithLandlord")}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>

        <div className="user-role-row">
          <div className="indicator gray" />
          <div className="role-content">
            <span className="role-count">{sessions?.countByRole?.tenantWithoutLandlord || 0}</span>
            <span className="role-text">TENANTS WITHOUT LANDLORD</span>
          </div>
          {(sessions?.countByRole?.tenantWithoutLandlord || 0) > 0 && (
            <img 
              src={infoIcon} 
              alt="Info" 
              className="info-icon" 
              onClick={() => handleUsersListClick("tenantWithoutLandlord")}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>

        <div className="user-role-row">
          <div className="indicator gray" />
          <div className="role-content">
            <span className="role-count">{sessions?.countByRole?.owner || 0}</span>
            <span className="role-text">OWNERS</span>
          </div>
          {(sessions?.countByRole?.owner || 0) > 0 && (
            <img 
              src={infoIcon} 
              alt="Info" 
              className="info-icon" 
              onClick={() => handleUsersListClick("owner")}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>

        <div className="user-role-row">
          <div className="indicator gray" />
          <div className="role-content">
            <span className="role-count">{sessions?.countByRole?.communityManager || 0}</span>
            <span className="role-text">COMMUNITY MANAGERS</span>
          </div>
          {(sessions?.countByRole?.communityManager || 0) > 0 && (
            <img 
              src={infoIcon} 
              alt="Info" 
              className="info-icon" 
              onClick={() => handleUsersListClick("communityManager")}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>

        <div className="user-role-row">
          <div className="indicator gray" />
          <div className="role-content">
            <span className="role-count">{sessions?.countByRole?.userWithoutProperty || 0}</span>
            <span className="role-text">USERS WITHOUT PROPERTY</span>
          </div>
          {(sessions?.countByRole?.userWithoutProperty || 0) > 0 && (
            <img 
              src={infoIcon} 
              alt="Info" 
              className="info-icon" 
              onClick={() => handleUsersListClick("userWithoutProperty")}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>
      </div>

      {/* Row 4: Language usage */}
      <div className="language-section">
        <h4 className="language-title">LANGUAGE</h4>
        <div className="language-content">
          {sessions.loading ? (
            <Statistics.LoaderInline />
          ) : (
            <Statistics.Horizontal
              data={sessions?.languagesUsage?.map((lang) => ({
                value: lang.language,
                label: lang.count,
                info: true, // Enable info icon for each language
              }))}
              handleInfo={handleLanguageInfo}
            />
          )}
        </div>
      </div>

      {/* Row 5: Permissions section */}
      <div className="permissions-section">
        <h4 className="permissions-title">PERMISSIONS</h4>
        <div className="permissions-content">
          <div className="permission-row">
            <div className="indicator gray" />
            <div className="permission-content">
              <span className="permission-count">{sessions?.allowedNotifications ?? 0}</span>
              <span className="permission-text">NOTIFICATIONS</span>
            </div>
            {(sessions?.allowedNotifications ?? 0) > 0 && (
              <img 
                src={infoIcon} 
                alt="Info" 
                className="info-icon" 
                onClick={() => handleUsersListClick()}
                style={{ cursor: "pointer" }}
              />
            )}
          </div>
          <div className="permission-row">
            <div className="indicator gray" />
            <div className="permission-content">
              <span className="permission-count">{sessions?.allowedLocation && sessions.allowedLocation > 0 ? sessions.allowedLocation : "TO DO"}</span>
              <span className="permission-text">LOCATIONS</span>
            </div>
            {sessions?.allowedLocation && sessions.allowedLocation > 0 && (
              <img 
                src={infoIcon} 
                alt="Info" 
                className="info-icon" 
                onClick={() => handleUsersListClick()}
                style={{ cursor: "pointer" }}
              />
            )}
          </div>
        </div>
      </div>

      {/* Row 6: Deleted accounts section */}
      <div className="deleted-accounts-section">
        <h4 className="deleted-accounts-title">DELETED ACCOUNTS</h4>
        <div className="deleted-accounts-content">
          <div className="deleted-account-row">
            <div className="indicator gray" />
            <div className="account-content">
              <span className="account-count">{sessions?.deletedUsersWithoutProperties ?? 0}</span>
              <span className="account-text">WITHOUT PROPERTIES</span>
            </div>
          </div>
          <div className="deleted-account-row">
            <div className="indicator gray" />
            <div className="account-content">
              <span className="account-count">{sessions?.deletedUsersWithProperties ?? 0}</span>
              <span className="account-text">WITH AT LEAST ONE PROPERTY</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sessions: state.dashboard.sessions,
});

const mapDispatchToProps = (dispatch) => ({
  getStatisticsSessions: (payload) => dispatch(getStatisticsSessions(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Registrations);
